import { appRoutes } from '@clearverify/constants';

import { DropdownNavigationRoute } from 'src/components/common';
import { ReportTypeLabels } from 'src/constants/reports';

export const REPORT_ROUTES_CLEARVERIFY_MANAGER: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.DataDisputes,
    path: appRoutes.reports.dataDisputes,
    titleContent: ReportTypeLabels.DataDisputes,
  },
  {
    label: ReportTypeLabels.VerificationRequests,
    path: appRoutes.reports.verificationRequests,
    titleContent: ReportTypeLabels.VerificationRequests,
  },
];

export const REPORT_ROUTES_CLEARVERIFY_ADMIN: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.DataDisputes,
    path: appRoutes.reports.dataDisputes,
    titleContent: ReportTypeLabels.DataDisputes,
  },
  {
    label: ReportTypeLabels.VerificationRequests,
    path: appRoutes.reports.verificationRequests,
    titleContent: ReportTypeLabels.VerificationRequests,
  },
];

export const REPORT_ROUTES_CONSUMER: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.Requests,
    path: appRoutes.reports.requests,
    titleContent: ReportTypeLabels.Requests,
  },
];

export const REPORT_ROUTES_EMPLOYER_MANAGER: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.DataDisputes,
    path: appRoutes.reports.dataDisputes,
    titleContent: ReportTypeLabels.DataDisputes,
  },
  {
    label: ReportTypeLabels.VerificationRequests,
    path: appRoutes.reports.verificationRequests,
    titleContent: ReportTypeLabels.VerificationRequests,
  },
];

export const REPORT_ROUTES_PEO_MANAGER: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.DataDisputes,
    path: appRoutes.reports.dataDisputes,
    titleContent: ReportTypeLabels.DataDisputes,
  },
  {
    label: ReportTypeLabels.VerificationRequests,
    path: appRoutes.reports.verificationRequests,
    titleContent: ReportTypeLabels.VerificationRequests,
  },
];

export const REPORT_ROUTES_EMPLOYER_ADMIN: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.Dashboard,
    path: appRoutes.reports.dashboard,
    titleContent: ReportTypeLabels.Dashboard,
  },
  {
    label: ReportTypeLabels.DataDisputes,
    path: appRoutes.reports.dataDisputes,
    titleContent: ReportTypeLabels.DataDisputes,
  },
  {
    label: ReportTypeLabels.VerificationRequests,
    path: appRoutes.reports.verificationRequests,
    titleContent: ReportTypeLabels.VerificationRequests,
  },
];

export const REPORT_ROUTES_PEO_ADMIN: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.Dashboard,
    path: appRoutes.reports.dashboard,
    titleContent: ReportTypeLabels.Dashboard,
  },
  {
    label: ReportTypeLabels.DataDisputes,
    path: appRoutes.reports.dataDisputes,
    titleContent: ReportTypeLabels.DataDisputes,
  },
  {
    label: ReportTypeLabels.VerificationRequests,
    path: appRoutes.reports.verificationRequests,
    titleContent: ReportTypeLabels.VerificationRequests,
  },
];

export const REPORT_ROUTES_PEOPP: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.Dashboard,
    path: appRoutes.reports.dashboard,
    titleContent: ReportTypeLabels.Dashboard,
  },
  {
    label: ReportTypeLabels.DataDisputes,
    path: appRoutes.reports.dataDisputes,
    titleContent: ReportTypeLabels.DataDisputes,
  },
  {
    label: ReportTypeLabels.VerificationRequests,
    path: appRoutes.reports.verificationRequests,
    titleContent: ReportTypeLabels.VerificationRequests,
  },
];

export const REPORT_ROUTES_VERIFIER: DropdownNavigationRoute[] = [
  {
    label: ReportTypeLabels.VerificationRequests,
    path: appRoutes.reports.verificationRequests,
    titleContent: ReportTypeLabels.VerificationRequests,
  },
];
